var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/scan-barcode"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scan-barcode"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 7.5013V5.41797C1.66699 3.34297 3.34199 1.66797 5.41699 1.66797H7.50033",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 7.5013V5.41797C1.66699 3.34297 3.34199 1.66797 5.41699 1.66797H7.50033",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 1.66797H14.5833C16.6583 1.66797 18.3333 3.34297 18.3333 5.41797V7.5013",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.333 13.332V14.582C18.333 16.657 16.658 18.332 14.583 18.332H13.333",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.50033 18.3333H5.41699C3.34199 18.3333 1.66699 16.6583 1.66699 14.5833V12.5",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.74967 5.83203V7.4987C8.74967 8.33203 8.33301 8.7487 7.49967 8.7487H5.83301C4.99967 8.7487 4.58301 8.33203 4.58301 7.4987V5.83203C4.58301 4.9987 4.99967 4.58203 5.83301 4.58203H7.49967C8.33301 4.58203 8.74967 4.9987 8.74967 5.83203Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4167 5.83203V7.4987C15.4167 8.33203 15 8.7487 14.1667 8.7487H12.5C11.6667 8.7487 11.25 8.33203 11.25 7.4987V5.83203C11.25 4.9987 11.6667 4.58203 12.5 4.58203H14.1667C15 4.58203 15.4167 4.9987 15.4167 5.83203Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.74967 12.5V14.1667C8.74967 15 8.33301 15.4167 7.49967 15.4167H5.83301C4.99967 15.4167 4.58301 15 4.58301 14.1667V12.5C4.58301 11.6667 4.99967 11.25 5.83301 11.25H7.49967C8.33301 11.25 8.74967 11.6667 8.74967 12.5Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.4167 12.5V14.1667C15.4167 15 15 15.4167 14.1667 15.4167H12.5C11.6667 15.4167 11.25 15 11.25 14.1667V12.5C11.25 11.6667 11.6667 11.25 12.5 11.25H14.1667C15 11.25 15.4167 11.6667 15.4167 12.5Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeIcon);
export default __webpack_public_path__ + "static/media/barcode_icon.dfe5b3877b728fc39160d9f7cc11aebd.svg";
export { ForwardRef as ReactComponent };